<template>
  <div class="writeDoc content-item flex align-items-center">
    <div class="content-item-label" v-if="isFlag"><span class="red" v-if="JSON.parse(commonData[0].value)==='1'">*</span>{{ JSON.parse(commonData[1].value) }}</div>
    <el-select
      v-model="select"
      filterable
      placeholder="请选择"
      size="mini"
      class="selectBus"
      remote
      :remote-method="remote"
      :loading="write_doctor_loading"
      @change="$emit('writeChange')"
      clearable
    >
      <el-option
        v-for="(item,index) in writeOptions"
        :key="index"
        :label="`${item.docName}  ${item.titleName}  ${item.hospitalGradeName}  ${item.hospitalName}  ${item.departName}`"
        :value="item.docId"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "WriteDoctor",
  props: ['writeDoctor', 'writeOptions', 'write_doctor_loading', 'flag', 'isFlag', 'Pharmacist', 'isWriteDoctor', 'commonData'],
  computed: {
    select: {
      get() {
        return this.writeDoctor
      },
      set(val) {
        this.$emit('update:writeDoctor', val)
      }
    },
  },
  methods: {
    remote(query) {
      this.$emit('write_remoteMethod', query)
    }
  }
}
</script>

<style lang="scss" scoped>
.red{
  color: #f62458;
	margin-right: 5px;
}

</style>
